/**
 * Black Friday 2026 homepage (sections/leds-bf-*.liquid):
 * - countdown under the banner
 * - "Vezi toate" on the spotlight posters
 * - category rows fetched near the screen (Section Rendering API, sections/leds-bf-rail),
 *   with arrows; an empty row is removed with its chip
 * - add to cart from the posters and the row cards (mini cart opens through Warehouse's
 *   product:added event, as in leds-product.js)
 * Every section loads this file, so it runs once.
 */
(function () {
  if (window.ledsBf) return;
  window.ledsBf = true;

  /* ---------- countdown ---------- */

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function startCountdown(el) {
    var end = Date.parse(el.getAttribute('data-end'));
    if (isNaN(end)) return;
    var parts = {
      d: el.querySelector('[data-d]'),
      dLabel: el.querySelector('[data-d-label]'),
      h: el.querySelector('[data-h]'),
      m: el.querySelector('[data-m]'),
      s: el.querySelector('[data-s]')
    };

    function tick() {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (left === 0) {
        el.hidden = true;
        return;
      }
      var d = Math.floor(left / 86400);
      parts.d.textContent = d;
      parts.dLabel.textContent = d === 1 ? 'zi' : 'zile';
      parts.h.textContent = pad(Math.floor((left % 86400) / 3600));
      parts.m.textContent = pad(Math.floor((left % 3600) / 60));
      parts.s.textContent = pad(left % 60);
      setTimeout(tick, 1000 - (Date.now() % 1000));
    }
    tick();
  }

  /* ---------- category rows ---------- */

  function setupArrows(cat, track) {
    var prev = cat.querySelector('[data-prev]');
    var next = cat.querySelector('[data-next]');
    if (!prev || !next) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    function go(direction) {
      track.scrollBy({ left: direction * track.clientWidth * 0.9, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function removeRow(cat) {
    var handle = cat.getAttribute('data-leds-bf-cat');
    var root = cat.closest('.leds-bf-deals');
    var chip = root && root.querySelector('[data-chip="' + handle + '"]');
    if (chip) chip.remove();
    cat.remove();
  }

  function loadRail(rail) {
    var cat = rail.closest('[data-leds-bf-cat]');
    var track = rail.querySelector('[data-track]');

    fetch(rail.getAttribute('data-src'), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('.leds-bf-rail-src');
        var count = list ? parseInt(list.getAttribute('data-count'), 10) || 0 : 0;
        if (!count) {
          removeRow(cat);
          return;
        }
        var maxItem = list.querySelector('[data-leds-bf-max]');
        var max = maxItem ? parseInt(maxItem.getAttribute('data-leds-bf-max'), 10) || 0 : 0;
        if (maxItem) maxItem.remove();

        track.innerHTML = list.innerHTML;
        if (max > 0) {
          var pct = cat.querySelector('[data-pct]');
          pct.querySelector('[data-pct-value]').textContent = max;
          pct.hidden = false;
        }
        setupArrows(cat, track);
      })
      .catch(function () {
        removeRow(cat);
      });
  }

  /* ---------- add to cart ---------- */

  function onAddToCart(event) {
    var button = event.target.closest('[data-leds-bf-add], .leds-bf [data-action="add-to-cart"]');
    if (!button) return;
    if (window.theme && window.theme.cartType === 'page') return; // the form posts to the cart page

    var form = button.closest('form');
    if (!form) return;
    event.preventDefault();

    var id = parseInt(form.querySelector('[name="id"]').value, 10);
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    var url = ((window.routes && window.routes.cartAddUrl) || '/cart/add') + '.js';

    button.disabled = true;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: id, quantity: quantity })
    })
      .then(function (response) {
        button.disabled = false;
        if (response.ok) {
          button.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { button: button, variant: null, quantity: quantity }
          }));
        } else {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          window.location.href = form.closest('article, .product-item').querySelector('a[href*="/products/"]').href;
        }
      })
      .catch(function () {
        button.disabled = false;
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
  }

  /* ---------- start ---------- */

  function init() {
    document.querySelectorAll('[data-leds-bf-countdown]').forEach(startCountdown);

    document.querySelectorAll('[data-leds-bf-more]').forEach(function (button) {
      button.addEventListener('click', function () {
        var section = button.closest('[data-leds-bf-spotlight]');
        section.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        var firstHidden = section.querySelector('.leds-bf-poster--more a[href]:not([tabindex])');
        if (firstHidden) firstHidden.focus({ preventScroll: true });
      });
    });

    var rails = document.querySelectorAll('[data-leds-bf-rail]');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          loadRail(entry.target);
        });
      }, { rootMargin: '700px 0px' });
      rails.forEach(function (rail) { observer.observe(rail); });
    } else {
      rails.forEach(loadRail);
    }

    document.addEventListener('click', onAddToCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
